
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { SupportCasesApi } from "./api";
import SupportCasesGrid from "./SupportCasesGrid";
import AddSupportCaseDialog from "./AddSupportCaseDialog";
import { Button } from "@progress/kendo-react-buttons";

interface SupportCasesWidgetProps {
  id: string;
  header: string;
}

const GridWidget = (props: SupportCasesWidgetProps) => {
  const [SupportCases, updateSupportCases] = useState(null);
  const [SupportCasesLoading, updateLoadingSupportCases] = useState(true);
  const [SupportCaseTypes, updateSupportCaseTypes] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
    const globalParams = useSelector(getParamsSelector);

  const [dialogVisible, updateDialogVisible] = useState(false);

  const toggleDialog = () => {
    dialogVisible ? updateDialogVisible(false) : updateDialogVisible(true);
  };
  useEffect(() => {
    getSupportCaseTypes();
  }, []);

    useEffect(() => {
        if (dialogVisible == false) {
            if (
                globalParams.customerID != null &&
                globalParams.mainMachineSerialNo == null
            ) {
                updateLoadingSupportCases(true);
                getSupportCases(globalParams.customerID);
            } else if (globalParams.mainMachineSerialNo != null) {
                updateLoadingSupportCases(true);
                getMachineSupportCases(globalParams.mainMachineSerialNo);
            }
        }
    }, [globalParams.customerID, globalParams.mainMachineSerialNo, dialogVisible]);

    const getSupportCaseTypes = () => {
    SupportCasesApi.getSupportCaseTypes()
      .then((response: any) => {
        let elementid: any = 0;
        for (var i = 0; i < response.length; i++) {
          var type = response[i];
          if (type.name == "Technical problem") {
            elementid = i;
          }
        }
        var id = response[elementid];
        response.splice(elementid, 1);
        response.unshift(id);
        updateSupportCaseTypes(response);

        setErrorMessage(null);
      })
      .catch((error) => {
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  const getSupportCases = (cId) => {
    let params: any = { customerId: cId };
    SupportCasesApi.getCustomerSupportCases(params)
      .then((response: any) => {
          updateSupportCases(response.issues);
        //console.log(response.issues)
        updateLoadingSupportCases(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingSupportCases(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const getMachineSupportCases = (m) => {
    let params: any = { machineSerial: m };
    SupportCasesApi.getMachineSupportCases(params)
      .then((response: any) => {
         // console.log(response)
        var jiraIssuesStrArr = response.substring(1).split("COMMA");
        var issues = [];
        for (var i = 0; i < jiraIssuesStrArr.length; i++) {
          var objIssues = JSON.parse(jiraIssuesStrArr[i]);
          if (objIssues.issues != undefined) {
              for (var j = 0; j < objIssues.issues.length; j++) {
                  var issue = objIssues.issues[j];
                  // Check if the issue already exists based on a unique identifier (e.g., issue.id)
                  var exists = false;
                  for (var k = 0; k < issues.length; k++) {
                      if (issues[k].id === issue.id) {
                          exists = true;
                          break;
                      }
                  }
                  if (!exists) {
                      issues.push(issue);
                  }
              }
          }
        }
        updateSupportCases(issues);
        updateLoadingSupportCases(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingSupportCases(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (SupportCasesLoading) {
    return <Spinner text="support cases" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }

   
  return (
      <div style={{ height: "100%" }}>
          <div style={{ padding: "2px", marginLeft: "60px",marginBottom:"5px" }}>
        <Button onClick={() => toggleDialog()}>Create Support Case</Button>
      </div>
      <div style={{ height: "calc(100% - 34px)" }}>
        <SupportCasesGrid data={SupportCases} />
      </div>
     
      <AddSupportCaseDialog
        visible={dialogVisible}
        toggleVisible={toggleDialog}
        customerId={globalParams.customerID}
        machine={globalParams.mainMachineSerialNo}
        types={SupportCaseTypes}
      />
    </div>
  );
};

export default GridWidget;
